import React, { useState } from 'react';
import GroupIcon from '@material-ui/icons/Group';
import { Avatar, Box, ButtonBase, CircularProgress, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

import { useMeetingDetailsStyle } from './meeting-details.style';

export const InvitedUsersComponent = ({
  meetingUsers,
  meeting,
  user,
  selectRequest,
}) => {
  const classes = useMeetingDetailsStyle();
  const [isLoading, setIsLoading] = useState(false);

  const meetingHost = () =>
    meeting && meeting.members.filter((item) => item.status === 0)[0];

  const ChooseRequest = ({ uid }) => (
    <Box display='flex' justifyContent={isLoading ? 'end' : 'space-between'} width={65}>
      {!isLoading && (
        <>
          <ButtonBase
            disabled={isLoading}
            onClick={() => selectRequest(1, setIsLoading, uid, meeting.id)}
          >
            <CloseIcon color='error' />
          </ButtonBase>
          <ButtonBase
            disabled={isLoading}
            onClick={() => selectRequest(0, setIsLoading, uid, meeting.id)}
          >
            <CheckIcon color='secondary' />
          </ButtonBase>
        </>
      )}
      {isLoading && (
        <CircularProgress size={24}  />
      )}
    </Box>
  );

  let status = (i, uid) => {
    let component = {
      0: 'Host',
      1: 'Joined',
      2: 'Rejected',
      3: 'Invited',
      4:
        user && user.uid === meetingHost().member_uuid ? (
          <ChooseRequest uid={uid} />
        ) : (
          'Requested'
        ),
      5: 'Accepted by Host',
      6: 'Rejected by the host',
    };
    return component[i];
  };

  return (
    <div>
      <Box display='flex' alignItems='center' mb={2}>
        <GroupIcon color='secondary' className={classes.icon} />
        <Typography>Participants:</Typography>
      </Box>
      <Box className={classes.memberList} maxHeight={500}>
        {meetingUsers &&
          meetingUsers.map((user, index) => (
            <Box
              display='flex'
              justifyItems='center'
              justifyContent='space-between'
              alignItems='center'
              my={1}
              key={index}
            >
              <Box display='flex'>
                <Avatar className={classes.avatar} src={user.avatar}>
                  {user.username
                    ? user.username[0].toUpperCase()
                    : user.email && user.email[0].toUpperCase()}
                </Avatar>
                <Link
                  style={{
                    color: '#000',
                    textDecoration: user.uid ? 'underline' : 'none',
                  }}
                  to={
                    user.uid
                      ? `/user/profile/${
                          user.username
                            ? user.username
                            : user.email && user.email
                        }`
                      : null
                  }
                >
                  {user.username
                    ? `@${user.username}`
                    : user.email && user.email}
                </Link>
              </Box>

              <Box mx={2}>
                <Box>
                  {meeting &&
                    meeting.members
                      .filter((item) => item.member_uuid === user.uid)
                      .map((i) => status(i.status, i.member_uuid))}
                </Box>
                <Box>
                  {meeting &&
                    meeting.members
                      .filter(
                        (item) =>
                          item.member_uuid === null && item.email === user.email
                      )
                      .map((i) => status(i.status, null))}
                </Box>
              </Box>
            </Box>
          ))}
      </Box>
    </div>
  );
};
